import React from 'react';

import DetailsHeader from 'components/DetailsComponents/Header';
import BreadcrumbsNav from 'components/BreadcrumbsNav/BreadcrumbsNav';

import { ASSETS_LIST_PATH, BATCH_OF_ASSETS_CREATION_PATH } from 'constants/routeConstants';

import { useMobileViewport } from 'hooks/useMobileViewport';

export default function Header({ onLinkClick }) {
  const isMobile = useMobileViewport();

  const crumbs = [
    { name: 'Asset Summary', path: ASSETS_LIST_PATH },
    { name: 'Create Batch of Assets', path: BATCH_OF_ASSETS_CREATION_PATH },
    { name: 'Preview' }
  ];

  const CrumbsComponent = !isMobile && (
    <BreadcrumbsNav itemsArray={crumbs} onLinkClick={onLinkClick} />
  );

  return <DetailsHeader title="Preview Batch of Assets" BreadCrumbsComponent={CrumbsComponent} />;
}
